import type { IndexFilterOrdering } from '@/components/page-sections/index-section-utils';
import type { BlogRecord } from '@/lib/blocks/collection/records';
import type { PaginationInfo } from '@/types/pagination';
import type { Topic } from '@/types/shared';

export interface PaginatedBlogs {
  data: BlogRecord[];
  pinned?: BlogRecord[];
  pagination: PaginationInfo;
}

export interface BlogIndexFilters {
  topics?: string[];
  authorId?: string;
}

export interface BlogIndexProps {
  pinned?: BlogRecord[];
  pinnedHeading?: string;
  pinnedDescription?: string;
  backgroundColor?: string | null;
  backgroundFullWidth?: boolean;
  blogs?: PaginatedBlogs;
  topics?: Topic[];
  showFilters?: boolean;
  filterLimit?: number;
  filterOrdering?: IndexFilterOrdering;
  perPage?: number;
  orderBy?: string;
  filters?: BlogIndexFilters;
}

export enum BlogIndexVariant {
  LIST_LAYOUT = 'list',
  GRID_LAYOUT = 'grid',
  SPLIT_LAYOUT = 'split',
}
